import {SolicitationFinancePreferences, SolicitationFinancePreferencesForm} from "../../types/financing/financingData";
import {HttpAxiosRequest} from "../httpAxiosBase";


export const HttpSolicitationFinancing = {
    getEndpoint: (solicitationId: number, url = "") => `solicitud/${solicitationId}/preferencias${url}`,

    get: (solicitationId: number) : Promise<SolicitationFinancePreferences> => {
        return HttpAxiosRequest.get(
            HttpSolicitationFinancing.getEndpoint(solicitationId)
        )
    },
    
    insert : (solicitationId: number, financingData: SolicitationFinancePreferencesForm) : Promise<any> => {
        return HttpAxiosRequest.post(
            HttpSolicitationFinancing.getEndpoint(solicitationId),
            {...financingData}
        )
    }
}